import { useMemo } from 'react'

import { useRequest } from 'ahooks'
import { createStyles } from 'antd-style'

import { querySupplyDemandPageApi } from '@eastcoal/api/trade/supplyDemandMall/querySupplyDemandPage'

import { BasicProps } from '@eastcoal/common/types/component'
import { pick } from '@eastcoal/common/utils/object'
import { gotoLogin } from '@eastcoal/common/utils/route'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'

import { SupplyDemandTag } from '../../../../components/SupplyDemandTag'
import { SUPPLY_DEMAND_DETAIL_PAGE_PATH } from '../../../Content/SupplyDemand/constants/path'
import { HomeProList } from '../../components/ProList'
import { HomeProListProps } from '../../components/ProList/interface'

const useStyles = createStyles(({ token }) => ({
  phone: {
    color: token.volcano
  },
  tip: {
    color: token.colorTextTertiary,
    fontSize: token.fontSizeSM
  },
  time: {
    color: token.colorTextTertiary
  },
  link: {
    [`&:hover`]: {
      color: token.colorLinkHover
    },
    [`&:active`]: {
      color: token.colorLinkActive
    }
  }
}))

export const SupplyDemandList = (props: BasicProps) => {
  const { data, loading } = useRequest(querySupplyDemandPageApi, {
    manual: false,
    retryCount: 5,
    retryInterval: 1000,
    defaultParams: [
      {
        current: '1',
        pageSize: '10',
        statusList: [1],
        orders: [
          {
            column: 'updated_time',
            asc: false
          }
        ]
      },
      {
        silence: true
      }
    ]
  })

  const { logined } = useAuthStore(state => pick(state, ['logined']))

  const { styles } = useStyles()

  const dataSource = useMemo(() => {
    if (!data?.records) return []

    return data.records.map(
      ({ id, type, content, contactTelephone, createdTime }) => ({
        id,
        title: logined ? (
          content || '无'
        ) : (
          <div
            className={styles.link}
            role='button'
            tabIndex={-1}
            onClick={gotoLogin}
          >
            {content || '无'}
          </div>
        ),
        icon: <SupplyDemandTag type={type} />,
        desc: (
          <>
            <div className={styles.phone}>
              <span>电话: {contactTelephone}</span>
              {!logined && <span className={styles.tip}>（登录后可见）</span>}
            </div>
            <div className={styles.time}>{createdTime}</div>
          </>
        )
      })
    ) as HomeProListProps['dataSource']
  }, [data, logined])

  return (
    <HomeProList
      {...props}
      dataSource={dataSource}
      detailPath={logined ? SUPPLY_DEMAND_DETAIL_PAGE_PATH : undefined}
      loading={loading}
    />
  )
}
